<div class="page-container page-containers content-w-98">
  <div class="page-head">
    <div>
      <div class="page-title">
        <p class="headerName">{{ headerData!.materialName }}</p>
      </div>
    </div>
  </div>
  <div class="page-content responsive-height">
    <div>
      <div class="EOL-Content-Div">
        <!-- Country Dropdown Section -->
        <div class="row mb-4" [formGroup]="eolFormGroup">
          <div class="custom-drpdown-width col-md-5">
            <label *ngIf="eolFormGroup.get('country')?.value" class="sub-header-drpdown pb-2"
              >Where is the end-of-life region?</label
            >
            <ng-select
              [clearable]="false"
              #country
              [items]="countryList"
              [searchable]="false"
              bindLabel="name"
              formControlName="country"
              bindValue="id"
              (change)="changeCountry($event)"
              placeholder="Where is the end-of-life region?"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="country.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-12"
            *ngrxLet="{
              dataLoaded: (sharedFacade.isLoaded$ | async),
              isClearSearch: (sharedFacade.isClearSearch$ | async)
            } as sharedData"
          >
            <piqet-angular-portlet
              [columnDefs]="columnDefs"
              [frameworkComponents]="frameworkComponents"
              [createAccess]="showEdit"
              [headerBtn]="'Add product EOL'"
              [hideSearch]="true"
              [hidePagination]="true"
              [gridData]="productEOLData"
              (openBtnModal)="addEditEOLModal(0, 'Add product EOL')"
              [isClearSearch]="sharedData.isClearSearch"
              [gridName]="'Product eol'"
              [class]="'scrollGrid'"
              [isEOLGrid]="true"
            ></piqet-angular-portlet>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer pt-3 mt-4">
      <button type="button" class="btn back-btn modelBtn" (click)="backRoute()">
        <i class="bi bi-arrow-left checkboxLeft-div"></i> Back
      </button>
      <button type="button" class="btn next-btn modelBtn" (click)="nextRoute()">
        {{ backBtnLabel }} <i class="bi bi-arrow-right checkbox-div"></i>
      </button>
    </div>
  </div>
</div>
